import * as Sentry from '@sentry/browser';

interface Config {
	sentryDsn: string;
	sentryTunnel: string | null;
	environment: string;
	release: string;
	resolveUrlPath: () => string;
}

export default function init({ sentryDsn, sentryTunnel, environment, release, resolveUrlPath }: Config) {
	const options: Sentry.BrowserOptions = {
		dsn: sentryDsn,
		environment,
		release,
		beforeSend: (data) => {
			if (data.fingerprint === undefined) {
				data.fingerprint = ['{{ default }}', resolveUrlPath()];
			}
			return data;
		},
		ignoreErrors: [
			"Cannot read property '_avast_submit' of undefined",
			'ResizeObserver loop limit exceeded',
			'l.LegacyGlobal.should_do_lastpass_here is not a function.',
			"NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
			"NotFoundError: Failed to execute 'insertBefore' on 'Node': The node before which the new node is to be inserted is not a child of this node.",
			'Event `Event` (type=unhandledrejection) captured as promise rejection',
		],
	};

	if (sentryTunnel !== null) {
		options.tunnel = sentryTunnel;
	}

	Sentry.init(options);
}
